import { getImage } from "gatsby-plugin-image";
import * as React from 'react';
export default {
  getImage,
  React
};